import { get } from "./api";

export async function getGoogleCalendarEvents(startDate: string, endDate: string) {
  const { data } = await get({
    path: `/google/calendar/events?start=${startDate}&end=${endDate}`,
  });
  return data;
}
